import React from 'react';
import '../../../styles/home_slider.scss';

export default function HowItWorksDevided() {
	return (
		<div className='container'>
			<div className="mt-5 mb-5">
				<section name="mortgage">
					<div style={{ textAlign: 'center' }}>
						<h3 style={{ textDecoration: 'none' }}>The Trade-In Mortgage<span style={{ fontSize: '3.5vh', fontFamily: 'system-ui' }}>™</span></h3>
						<h2 className="jost-bold">HOW IT WORKS</h2>
					</div>
				</section>
				<div className="px-md-5">
					<div className="col-12 px-lg-5">
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: '#2661AB' }}>
									<span className="">1</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">Get pre-approved quickly and easily!</h4>
									<ul className="pl-3" type="square">
										<li>
											Answer the questionnaire in less than 5 minutes and Calque will send you a purchase price guarantee (PPG) within 3-5 business days.
										</li>
										<li>
											Complete your pre-approval paperwork with your lender.
										</li>
										<li>
											Accept your PPG.
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: '#2661AB' }}>
									<span className="">2</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">Buy your dream home with more bargaining power.</h4>
									<ul className="pl-3">
										<li>
											Make competitive offers with confidence.
										</li>
										<li>
											Submit non-contingent offers that function like all-cash offers.
										</li>
										<li>
											Once your offer is accepted, your lender will finalize the underwriting process and give you the down payment for your new home.
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: '#2661AB' }}>
									<span className="">3</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">Prep Your original home for sale after you've moved out.</h4>
									<ul className="pl-3">
										<li>
											Move and prep your original home for sale.
										</li>
										<li>
											Make repairs and stage your original home so it sells for maximum value.
										</li>
										<li>
											Use the equity in your original home to make payments on that home so you’re only out-of-pocket for one mortgage.
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="d-flex w-100 justify-content-start px-lg-5 top-padding-small">
							<div className="col-auto pl-0 pr-3">
								<div className="how-list primary-background d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: '#2661AB' }}>
									<span className="">4</span>
								</div>
							</div>
							<div className="col px-0">
								<div className="how-content">
									<h4 className="montserrat-semibold">Sell your original home and save.</h4>

									<ul className="pl-3">
										<li>
											Move forward with a conventional loan on your new home.
										</li>
										<li>
											If your original home hasn’t sold within the specific timeframe (usually 120 days), Calque will purchase it for the PPG.
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
